<template lang="pug">
// 弹出框查看
div
    el-form(ref='form', :model='rowdata', label-width='110px')
        baseForm(:fatherdata="rowdata",:rowid="id")

        el-row( type="flex" class="line_box" justify="space-between")
            div 审批信息 
        //- el-form-item(label='展示顺序: ')
        //-     el-input(v-model='rowdata.sort', size='mini', style='width:50%')
        el-form-item(label='审批结果: ')
            el-radio-group(v-model='rowdata.approvalStatus',disabled)
                el-radio(label='1') 同意
                el-radio(label='2') 不同意
        el-form-item(label='审批意见: ')
            el-input(type='textarea', style='width:50%', :rows='4',disabled, placeholder='请输入内容', v-model='rowdata.approvalOpinion')
    .boontbtn
        el-button(v-if="!hadCheck", type='primary', size='small', style='margin: 0 30px', @click='saveAuditdata') 确认
        el-button(type='info', size='small', @click='closeDialog') 关闭
    div(v-show="showSendMessage")
        sendMessage( :show="showSendMessage",fatherdata="",:rowid="id",@func="sendMessageBack")

</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import baseForm from "./baseForm.vue";
import sendMessage from "./sendMessage.vue";
import editor_option from "../../../../utils/editorOption.js";

import {
  getConsulListOrg,
  consulApprovalConsult,
  consulApiDetail
} from "@/api/http.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "sendMessageAgin",
  props: ["rowid"],
  components: {
    quillEditor,
    baseForm,
    sendMessage
  },
  data() {
    return {
      hadCheck: false,
      showSendMessage: false,
      id: this.rowid,
      editorOption: editor_option.editorOption,
      rowdata: {
        orgPid: 0,
        orgId: 0,
        sort: 0
      },
      fileList: [],
      selectOrgs1: [],
      selectOrgs2: []
    };
  },
  methods: {
    sendMessageBack(e) {
      console.log(e);

      this.showSendMessage = false;
      this.$emit("func", []);
    },
    //获取所属组织
    async getOrg(selVal) {
      let fd = new FormData();
      fd.append("token", token);
      //获取父类
      if (selVal == "") {
        fd.append("parentId", 0);

        var res = await getConsulListOrg(fd);
        var temp = {};
        if (res.content && res.content.length > 0) {
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName };
            this.selectOrgs1.push(temp);
          });
        }
      } else {
        //获取子组织
        fd.append("parentId", selVal);

        var res = await getConsulListOrg(fd);

        this.selectOrgs2 = [];
        var temp = {};
        if (res.content && res.content.length > 0) {
          this.allOrgs = res.content;
          res.content.forEach(item => {
            temp = { id: item.id, value: item.id, label: item.orgName };
            this.selectOrgs2.push(temp);
          });
        }
      }
    },
    //点击查看显示弹出层
    async getData() {
      this.rowdata = {
        representative: [],
        professional: [],
        organization: [],
        interestParty: [],
        someoneElse: []
      };
      if (this.id != "") {
        //获取编辑项的最新数据
        let fd = new FormData();
        fd.append("token", token);
        fd.append("id", this.id);
        var res = await consulApiDetail(fd);
        // console.log(res)
        if (res.code == 200) {
          this.rowdata = res.content;
          //将字符串类型转换整型，select框中返回ID为整型
          this.rowdata.orgPid = 5; //parseInt(this.rowdata.orgPid)
          this.rowdata.orgId = parseInt(this.rowdata.orgId);
          this.getOrg(this.rowdata.orgPid);
        } else {
          this.rowdata = {};
          console.log(res.code + "：" + res.message);
          this.$message({
            message: "数据项加载异常",
            type: "error"
          });
        }
      } else {
        this.$message({
          message: "数据传输异常",
          type: "error"
        });
        this.rowdata = {};
        this.$emit("func", []);
      }
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    //审批接口
    async saveAuditdata() {
      this.showSendMessage = true;
      return;
      if (
        this.rowdata.approvalStatus == "" ||
        this.rowdata.approvalOpinion == ""
      ) {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false;
      }
      let fd = new FormData();
      fd.append("token", token);
      let params = JSON.stringify({
        id: this.rowdata.id,
        // sort: this.rowdata.sort,
        sort: 0,
        approvalStatus: this.rowdata.approvalStatus,
        approvalOpinion: this.rowdata.approvalOpinion
        // status: this.rowdata.approvalStatus=='1'?'1':'0'  //审批通过时，临时开启商议，进行后续操作
      });
      fd.append("approvalConsult", params);

      var res = await consulApprovalConsult(fd);

      this.hadCheck = true;
      if (res.code == 200) {
        this.$message({
          message: "审批成功",
          type: "success"
        });
        // this.$emit("func", []);
        this.showSendMessage = true;
      } else {
        console.log(res);
        this.$message({
          message: "审批失败：" + res.message,
          type: "error"
        });
      }
    },
    closeDialog() {
      this.showSendMessage = false;
      this.id = "";
      this.$emit("func", "showMessage");
    }
  },
  mounted() {
    this.getOrg("");
    this.getData();
  },
  watch: {
    rowid(val) {
      console.log(val);
      if (val) {
        this.id = val;
        this.getOrg();
        this.getData();
      } else {
        this.rowdata = {
          orgPid: 0,
          orgId: 0,
          sort: 0
        };
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
    }
    .tabBtn:nth-child(2) {
      color: #dd3020;
    }
    .tabBtn:nth-child(3) {
      color: #ff04ed !important;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
    }
    .active_Btn {
      color: #ff04ed !important;
    }
  }
}
.active_tab {
  color: #cd2b20 !important;
}
.active_tab1 {
  color: #0f7ef1 !important;
}
.active_tab2 {
  color: #1a9c5e !important;
}

.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.el-input__inner {
  color: #606266;
}
</style>
<style lang="less">
.main[data-v-336d350d] {
  min-width: 1578px !important ;
}
.el-form-item {
  margin-bottom: 1px;
}
.el-dialog__header {
  height: 40px;
  padding: 1px;
  background-color: #01aaef;
}
.el-dialog__headerbtn {
  position: absolute;
  top: 8px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 24px;
}
.el-dialog__title {
  display: block;
  margin-top: 9px;
  margin-left: 10px;
  color: #fff;
  font-size: 15px;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.el-progress-bar__inner {
  background-color: #93e3fc;
}
.el-progress-bar__outer {
  background-color: #01aaef;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>